/*jshint esversion: 6 */

import Vue from 'vue';
import './plugins/vuetify';


import App from './App.vue';
import router from './router';
import store from './store/store';

import firebase from 'firebase/app';
import 'firebase/firestore';

import './registerServiceWorker';
//import 'es6-promise/auto'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyD-9rfxq4aPocYscvldym7S9_ohWlaiCCs",
  authDomain: "invendio-ce64f.firebaseapp.com",
  databaseURL: "https://invendio-ce64f.firebaseio.com",
  projectId: "invendio-ce64f",
  storageBucket: "invendio-ce64f.appspot.com",
  messagingSenderId: "840803376968"
};

/* Initialize firebase with your configuration */
firebase.initializeApp(config);
 


/* Bind firebase to your Vue instance */
Vue.prototype.$firebase = firebase;

const db = firebase.firestore();
db.settings({ timestampsInSnapshots: true});


Vue.config.productionTip = false;

let app = null;

// Check before each page load whether the page requires authentication/
// if it does check whether the user is signed into the web app or
// redirect to the sign-in page to enable them to sign-in
router.beforeEach((to, from, next) => {

  const currentUser = firebase.auth().currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  
  if (requiresAuth && !currentUser) {
    //next('/login');
  } else if (requiresAuth && currentUser) {
    next();
  } else {
    next();
  }

});

// Wrap the vue instance in a Firebase onAuthStateChanged method
// This stops the execution of the navigation guard 'beforeEach'
// method until the Firebase initialization ends

firebase.auth().onAuthStateChanged (() => {

  if (!app) {
    app = new Vue({
      router,
      store,      
      render: h => h(App),
      created() {
        
      },
    }).$mount('#app');
  }      
});



